const THEMES = {
    LIGHT: {
        CLASS: 'theme--light',
        NAME: 'Light',
        VALUE: 'LIGHT',
        PRIMARY_COLOR: '#a43a45',
        WARNING_COLOR: '#a80c1c'
    },
    DARK : {
        CLASS: 'theme--dark',
        NAME: 'Dark',
        VALUE: 'DARK',
        PRIMARY_COLOR: '#D96970',
        WARNING_COLOR: '#f44336'
    },
    LIGHT_HIGH_CONTRAST: {
        CLASS: 'theme--light high--contrast',
        NAME: 'High contrast light',
        VALUE: 'LIGHT_HIGH_CONTRAST',
        PRIMARY_COLOR: '#121212',
        WARNING_COLOR: '#a80c1c'
    },
    DARK_HIGH_CONTRAST: {
        CLASS: 'theme--dark high--contrast',
        NAME: 'High contrast dark',
        VALUE: 'DARK_HIGH_CONTRAST',
        PRIMARY_COLOR: '#FFFFFF',
        WARNING_COLOR: '#f44336'
    }
}

export default THEMES;



// WEBPACK FOOTER //
// ./src/common/constants/themes.js